import axios from 'axios';

/** utility constants and functions */
import { BACKEND_URL } from '../utils/constants';
import { getSessionToken } from '../utils/session';

/** login and get otp endpoints */
export const PHONE_OTP = '/notification/phone_otp';
export const PROPOSAL_MOBILE_OTP = 'notification/proposal_mobile_otp/';
export const SIGN_IN = 'user/signin';
/** endpoint for cross login */
export const POS_TOKEN_LOGIN = 'ieadmin/pos_login/';
export const USER_PROFILE = 'pos/pos_profile/';
export const USER_BUSINESS = 'pos/pos_business/';
export const USER_LEAD = 'pos/lead/';

/** helper apis for dropdown data or inputs for other api */
export const SALUTATION = 'core/salutation/';
export const STATE_LIST = 'core/state/';
export const CITY_LIST = 'core/city/';
export const POLICY_COMPANY_LIST = 'core/policy_company/';
export const PROPOSAL_FORM = 'transaction/motor/proposal/';
export const Health = 'transaction/health_proposal/';

export const FINANCER_LIST = 'core/financier/';
export const OCCUPATION_LIST = 'core/occupation/';
export const PREVIOUS_POLICY_INSURER = 'core/prev_insurance_companies/';

/** tracking POS details endpoints */
export const POS_DETAILS = 'pos/pos_details/';
export const POS_DETAILS_PATCH = 'pos/pos_details/';
export const PROFILE_TRACKER = '/pos/pos_details_track/';

/** chapter info read and update endpoints */
export const CHAPTERS_LIST = 'training/chapter/';
export const CHAPTER_DURATION_LEFT = 'training/chapter_duration_update/';

/** exam related endpoints */
export const EXAM_ELIGIBILITY = '/training/pos_exam_validation/';
export const EXAM_QUESTIONS = 'training/chapter_question/';
/** submit answers for exam */
export const SUBMIT_EXAM = 'training/chapter_question_answer_submition/';
export const MINMAXIDV = 'transaction/min_max_idv/';
export const CLAIM = 'user/claim/';
export const LEAD_KPI = 'pos/pos_lead/';

/** transaction related apis from status as lead(initial) to policy booking(final)  */
export const RELATIONSHIP_LIST = 'transaction/relationship_list/';
export const PAYMENT_LINK = 'transaction/get_payment_details/';
export const PROPOSAL_REVIEW = 'transaction/proposal_review/';
export const TRANSACTION_TOKEN = 'transaction/transaction_token/';

/** axios instance with no Auth header set */
export const InstanceWithNoAuth = axios.create({
  baseURL: BACKEND_URL,
});

/** axios instance with Auth header set using Bearer token */
export const InstanceWithAuth = axios.create({
  baseURL: BACKEND_URL,
  headers: {
    Authorization: `Bearer ${getSessionToken()}`,
  },
});
